import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { EmailOrganizationSettings } from '../../entities/email-settings.model';
import { DashboardApiService } from '../db-api.service';

@Injectable({
  providedIn: 'root',
})
export class EmailSettingsService extends DashboardApiService {
  readonly API_URL = `/v1/issuer/organizations/${this.embedding.departmentId}`;

  getSettings(): Observable<EmailOrganizationSettings> {
    const url = `${this.API_URL}/email_settings`;

    return this._get(url).pipe(
      map((res) => this._handleResponse(res)),
      catchError((res) => this._handleError(res)),
    );
  }

  saveSettings(
    settings: Partial<EmailOrganizationSettings>,
  ): Observable<EmailOrganizationSettings> {
    const url = `${this.API_URL}/email_settings/upsert`;

    return this._post(url, { email_setting: settings }).pipe(
      map((res) => this._handleResponse(res)),
      catchError((res) => this._handleError(res)),
    );
  }

  sendConfirmationEmail(email: string): Observable<{ email: string; verified: boolean }> {
    const url = `${this.API_URL}/email_settings/confirm_from_email`;

    return this._post(url, { email }).pipe(
      map((res) => this._handleResponse(res)),
      catchError((res) => this._handleError(res)),
    );
  }
}
